import { CSSProperties } from "react";

export const modalBody: CSSProperties = {
  flex: 1,
};

export const modalContent: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export const resizeDiv: CSSProperties = {
  pointerEvents: "auto",
  position: "absolute",
  overflow: "hidden",
  resize: "both",
};
